import React from 'react';

import { Field } from 'formik';
import PropTypes from 'prop-types';
import { InputFormField } from '@playbookux/playbook-web-core';

import { withTranslation } from '../../../core/i18n';

import {
  Text,
  FieldContainerInput,
  InputContainer,
  ContainerInputText,
  ContentSegment,
} from './styles';

const InputTreeTest = ({
  phrases,
}) => (
  <>
    <ContentSegment>

      <FieldContainerInput>

        <ContainerInputText>
          <Text>
            {phrases.first_name}
          </Text>

          <InputContainer>
            <Field
              component={InputFormField}
              name="firstName"
              placeholder={phrases.first_name}
              widthsize="196px"
            />
          </InputContainer>

        </ContainerInputText>

        <ContainerInputText hasMarginTop>
          <Text>
            {phrases.last_name}
          </Text>

          <InputContainer>
            <Field
              component={InputFormField}
              name="lastName"
              placeholder={phrases.last_name}
              widthsize="196px"
            />
          </InputContainer>
        </ContainerInputText>

      </FieldContainerInput>
    </ContentSegment>
  </>
);

InputTreeTest.propTypes = {
  phrases: PropTypes.shape({
    launch_instructions: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    proceed_to_study_button: PropTypes.string,
    card_sort_launch_instructions: PropTypes.string,
  }).isRequired,
};

export default withTranslation(InputTreeTest);
